<template>
  <chart ref="daychart" :options="chartOptions" />
</template>
<script>
import { minBy } from 'lodash'
import moment from 'moment'
import { Chart } from 'highcharts-vue'

export default {
  components: {
    Chart,
  },
  props: ['dayChart', 'dayData', 'profile'],
  data: function () {
    return {
      chartOptions: {
        chart: {
          animation: false,
          type: 'line',
        },
        title: {
          text: null,
        },
        plotOptions: {
          series: {
            marker: {
              radius: 0,
              states: {
                hover: {
                  radiusPlus: 4,
                },
              },
            },
          },
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          valueDecimals: 2,
          valueSuffix: ' kW',
        },
        xAxis: {
          type: 'datetime',
        },
        yAxis: {
          title: {
            text: '', //"Nameraný výkon (kW)"
          },
        },
        series: [
          {
            name: 'Hodnota',
            color: '#6fa55a',
            data: [],
          },
          {
            name: 'MRK',
            showInLegend: false,
            color: '#000',
            lineWidth: 3,
            marker: {
              symbol: 'square',
            },
            data: [],
          },
          {
            name: 'RK',
            showInLegend: false,
            color: '#ff0000',
            dashStyle: 'dash',
            marker: {
              symbol: 'diamond',
            },
            data: [],
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadPDF'],
            },
          },
          filename: 'intervalove-data_report',
        },
      },
    }
  },
  watch: {
    dayChart: {
      handler() {
        this.chartUpdate()
      },
    },
    immediate: true,
  },
  methods: {
    chartUpdate: function () {
      if (Object.keys(this.dayChart).length && this.$refs.daychart) {
        this.chartOptions.series[0].data = this.dayChart.values
        /*this.chartOptions.series[0].zones = [
          {value: this.dayData.RK},
          {color: '#ff0000'}
        ];*/

        if (this.profile === 'consumption') {
          this.chartOptions.tooltip.valueSuffix = ' kW'
          this.chartOptions.series[1].showInLegend = true
          this.chartOptions.series[1].data = this.dayChart.mrk

          this.chartOptions.series[2].showInLegend = true
          this.chartOptions.series[2].data = this.dayChart.rk
        } else {
          this.chartOptions.tooltip.valueSuffix = ' kVAr'
          this.chartOptions.series[1].showInLegend = false
          this.chartOptions.series[1].data = []
          this.chartOptions.series[2].showInLegend = false
          this.chartOptions.series[2].data = []
        }
        this.chartOptions.xAxis.plotBands = [
          {
            from: moment(this.dayData.activeDate).valueOf(),
            to: moment(this.dayData.activeDate).add(1, 'day').valueOf(),
            color: 'rgba(113, 162, 65, .1)',
          },
        ]
      }

      const series1 = this.chartOptions.series[0]
      const series2 = this.chartOptions.series[2]

      if (series2.data.length) {
        series1.zones = [
          { value: minBy(series2.data, 'y')?.y },
          { color: '#ff0000' },
        ]
      }
    },
  },
}
</script>
